import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import Button from "@material-ui/core/Button";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import RoomContext from "../../../context/RoomContext";
import { Pie } from "react-chartjs-2";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: 28,
      textAlign: "center",
    },
    choices: {
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      width: "100%",
      marginTop: 12,
      gap: 8,
    },
    buttonChoice: {
      display: "flex",
      width: "100%",
      minHeight: 45,
      marginTop: 0,
      backgroundColor: "#ffffff",
      textTransform: "none",
      justifyContent: "flex-start",
      "&:hover": {
        backgroundColor: "#b0d7e1",
      },
    },
    chart: {
      width: 50,
      height: 50,
    },
    infoMessage: {
      color: "#3289ef",
    },
    divider: {
      backgroundColor: theme.palette.type === "dark" ? "#7a7a7a" : "#f7f8fd",
      height: 1,
      marginTop: 8,
      marginBottom: 8,
    },
  })
);

const Survey = () => {
  const classes = useStyles();
  const { roomClient } = useContext(RoomContext);
  const me = useSelector((state) => state.me);
  const currentSurvey = useSelector((state) => state.survey.currentSurvey);

  let answerData = [];

  if (currentSurvey && currentSurvey.answer) {
    for (let i = 0; i < currentSurvey.answer.length; i++) {
      answerData[currentSurvey.answer[i].choice]
        ? answerData[currentSurvey.answer[i].choice]++
        : (answerData[currentSurvey.answer[i].choice] = 1);
    }
  }
  const chartData = {
    labels: currentSurvey?.choices.map((choice) => choice.text),
    datasets: [
      {
        data: answerData,
        backgroundColor: [
          "#36A2EB",
          "#FF6384",
          "#FFCE56",
          "#A2C257",
          "#9090FF",
          "#9E0508",
          "#FDA3AA",
          "#66CDAA",
          "#F87531",
          "#DB9370",
          "#FFF68F",
        ],
        hoverBackgroundColor: [
          "rgba(54,162,235,0.75)",
          "rgba(255,99,132,0.76)",
          "rgba(255,206,86,0.75)",
          "#BED489",
          "#AAAAFF",
          "#F8171B",
          "#F6C9CC",
          "#93DCC3",
          "#FA9D6D",
          "#E5B299",
          "#FFFBC9",
        ],
      },
    ],
  };

  return (
    <div className={classes.root}>
      {!currentSurvey && (
        <Typography variant="h7" className={classes.infoMessage}>
          <FormattedMessage
            id="survey.noActiveSurvey"
            defaultMessage="There is no active survey"
          />
        </Typography>
      )}

      {currentSurvey && currentSurvey.answer && (
        <Pie
          className={classes.chart}
          data={chartData}
          width={50}
          height={50}
          options={{
            maintainAspectRatio: false,
            showLines: false,
          }}
        />
      )}
      <div className={classes.divider} />

      {currentSurvey?.question}
      {currentSurvey?.choices && (
        <div className={classes.choices}>
          {currentSurvey.choices.map((choice, index) => (
            <Button
              key={`survey-choice-${index}`}
              fullWidth
              variant="outlined"
              onClick={() => {
                roomClient.publishSurveyAnswer({
                  choice: index,
                });
              }}
              className={classes.buttonChoice}
              disabled={
                currentSurvey && currentSurvey.answer
                  ? currentSurvey.answer.filter((a) => a.senderId === me.id)
                      .length !== 0
                  : false
              }
            >
              {choice.text}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Survey;
